import { memo } from 'react';

import { ENACO_FACEBOOK_LINK, ENACO_LINKEDIN_LINK, ENACO_X_LINK } from '@didaskill/ui/domain';

import FacebookLogo from '../../../../../assets/logo/FacebookLogo.svg';
import LinkedInLogo from '../../../../../assets/logo/LinkedInLogo.svg';
import XLogo from '../../../../../assets/logo/XLogo.svg';
import * as styles from './LoginSocialMedias.styles';

const LoginPageSocialMediasBase = () => {
  return (
    <div css={styles.socialMedias}>
      <a target="_blank" rel="noreferrer" href={ENACO_FACEBOOK_LINK}>
        <FacebookLogo />
      </a>
      <a target="_blank" rel="noreferrer" href={ENACO_LINKEDIN_LINK}>
        <LinkedInLogo />
      </a>
      <a target="_blank" rel="noreferrer" href={ENACO_X_LINK}>
        <XLogo />
      </a>
    </div>
  );
};

export const LoginPageSocialMedias = memo(LoginPageSocialMediasBase);
